import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgCheckbox24 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" fillRule="evenodd" d="M7 5a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z" clipRule="evenodd" /></SvgIcon>;
};
const Memo = memo(SvgCheckbox24);
export default Memo;